"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILCalendarDatePicker = void 0;
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_date_picker_1 = require("../il-date-picker/il-date-picker");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
function ILCalendarDatePicker(_a) {
    var onChange = _a.onChange, onAccept = _a.onAccept, defaultValue = _a.value, _b = _a.inputFormat, inputFormat = _b === void 0 ? 'LLLL d' : _b, props = __rest(_a, ["onChange", "onAccept", "value", "inputFormat"]);
    var _c = react_1.default.useState(false), open = _c[0], setOpen = _c[1];
    var _d = react_1.default.useState(new Date()), value = _d[0], setValue = _d[1];
    var onChangeDate = function (date) {
        setValue(date);
        setOpen(false);
        onChange && onChange(date);
        onAccept && onAccept(date);
    };
    react_1.default.useEffect(function () {
        setValue(defaultValue || new Date());
    }, [defaultValue]);
    return (react_1.default.createElement(material_1.ClickAwayListener, { onClickAway: function () { return setOpen(false); } },
        react_1.default.createElement("div", null,
            react_1.default.createElement(il_date_picker_1.ILDatePicker, __assign({ onAccept: onChangeDate,
                onChange: onChangeDate, open: open, onOpen: function () { return setOpen(true); },
                onClose: function () { return setOpen(false); }, value: value, inputFormat: inputFormat, disableMaskedInput: true,
                mask: '',
                renderInput: function (inputProps) {
                    var _a;
                    return (react_1.default.createElement(material_1.Box, { className: "render-description", sx: { display: 'flex', alignItems: 'center', cursor: 'pointer' }, onClick: function () { return setOpen(!open); } },
                        react_1.default.createElement(material_1.Typography, { variant: "h3", ref: inputProps.inputRef, sx: {
                                whiteSpace: 'nowrap',
                            } }, defaultValue
                            ? (0, date_fns_1.format)(defaultValue, inputFormat)
                            : (_a = inputProps.inputProps) === null || _a === void 0 ? void 0 : _a.value),
                        react_1.default.createElement(material_1.IconButton, { onClick: function () { return setOpen(!open); }, "aria-label": "Show calendar" },
                            react_1.default.createElement(il_icon_common_1.SolidIcon, { size: enums_1.IconSizeEnum.XXSMALL, icon: open ? solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_UP : solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_DOWN }))));
                } }, props)))));
}
exports.ILCalendarDatePicker = ILCalendarDatePicker;
